import React from 'react';
import { SignOutIcon } from './Icons';
import { useDashboardContext } from '../context/DashboardContext';
import { useTranslation } from '../../../shared/i18n';

/**
 * Sign out button component
 * Automatically uses the correct sign out endpoint based on dashboard mode
 */
export const SignOutButton = ({ className = '' }) => {
  const { t } = useTranslation();
  const { signOutAction, translationPrefix } = useDashboardContext();

  const translationKey = translationPrefix === 'children'
    ? 'children.navigation.sign_out'
    : 'guardian.sidebar.sign_out';

  return (
    <form action={signOutAction} method="post" data-turbo="false" className={className}>
      <input type="hidden" name="_method" value="delete" />
      <input type="hidden" name="authenticity_token" value={document.querySelector('meta[name="csrf-token"]')?.content || ''} />
      <button
        type="submit"
        className="rounded-2 p-3 w-100 border-0 bg-transparent text-start d-flex align-items-center gap-3"
        style={{ cursor: 'pointer' }}
      >
        <SignOutIcon />
        <span className="text-secondary fw-medium">{t(translationKey)}</span>
      </button>
    </form>
  );
};

export default SignOutButton;
